<template>
  <div class="loginPage">
		<div class="loginComponent">
			<instructions
			></instructions>
		</div>
  </div>
</template>

<script>

export default {
	name: 'InstructionsPage',
	metaInfo: {
		title: 'Researcher Instructions'
	}
}
</script>
<style>
</style>
